import { render, staticRenderFns } from "./SetCorrespondenceVotesTable.vue?vue&type=template&id=28199fd0&"
import script from "./SetCorrespondenceVotesTable.vue?vue&type=script&lang=js&"
export * from "./SetCorrespondenceVotesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports